import '.df{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.dg{padding-left:1.5rem;}.ssr-plugin'
import '.dh{margin:1rem 0;}.ssr-plugin'
import '.di{color:var(--gray-700);}.ssr-plugin'
import '.dj{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="df dg dh di dj"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
